module.exports = __webpack_public_path__ + "static/img/ask2-tit.4787928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/ask2-tit.png
// module id = 2L98
// module chunks = 0